import {store} from '../store';

export const initializeStoreLocator = async () => {
    const storeId = findStoreInConfig(store.state.page.data)?.value || null;

    if (!storeId) return;

    const storeLocator = await fetch(`/api/store-locator/${storeId}`)
        .then(response => response.json())
        .catch(error => console.error(error));

    if (!storeLocator) return;

    storeLocator.translations = storeLocator.lang || {};

    store.commit('storeLocator/setupBaseData', storeLocator);
};



const findStoreInConfig = data => {
    if (!data || typeof data !== 'object') return null;

    for (const key in data) {
        if (key === 'storeLocatorId') {
            return data[key];
        }

        const value = data[key];
        if (typeof value === 'object') {
            const result = findStoreInConfig(value, 'storeLocatorId');
            if (result !== null) return result;
        }
    }

    return null;
};
